import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface CampMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface CampMst {
    id?: any;
   campName? :string;
 campType?:number;
   campDescription?:string;
   campDisplayValue?:string;
   campLocation?:string;
   status?:string;
   statusFlag?:string;
   statusReason?:string;
   activeFlag?:string;
    participantsDetail?:string;
    transportDetail?:string;
    plannedStartDate?:Date;
    plannedEndDate?:Date;
    actualStartDate?:Date;
    actualEndDate?:Date;
   medicineDetail?:string;
     city?:string;
       pincode?:string;
         state?:any;
    district?:any;
    country?:any;
    regId?:any;
    isPatientRegistered?:any;
     guestDetail?:string;
    address1?:string;
    address2?:string;
    createdDate?:Date;
     updatedDate?:Date;
     createdBy?:number;
    updatedBy?: number;
    createdIP?:string;
    updatedIP?:string;
    tenantId:any;
    branchId:any;
    parameters?: CampMstParameter[];
    links?: any;
}
export interface CampFileEntryDto { 

   employeeId:number;
   fileName:string;
   entryDate:Date;
   campId:number;
   tenantId:any;
   branchId:any;
   campFile: CampFileDto[];

}
export interface CampFileDto { 
   firstName:string;
   lastName?:string;
   dOB?:any;
   campId?:string;
   age?:number;
   gender?:string;
   maritalStatus:string;
   city?:string;
   district?:String;
   state?:string;
   country?:string;
   pincode?:string;
   address1?:string;
  address2?:string; 
  mobile?:string;
  alternateNo?:string;
  aaadhar?:string;
  drivingLicense?:string;
  doorNo?:string;
  bloodGroup?:string;
  email?:string;
  pancard?:string;
  nhid?:string;
  insuranceName?:string;
  insuranceDetails?:string;
  campPatientEhrNotes?:any;
  physicianId?:any;
}

export abstract class CampMstData {
    abstract list(url: string): Observable<CampMst[]>;
    abstract create(url: string, data: any): Observable<CampMst[]>;
    abstract createFile(url: string, data: any): Observable<any[]>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract update(url: string, data: CampMst): Observable<CampMst>;
    abstract delete(url: string): Observable<any>;
}
